import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { api } from "@/lib/api";
import { Crown, Coins, Trophy } from "lucide-react";

const BOARDS = [["pontos", "Pontos", Trophy], ["fichas", "Fichas", Coins]];

export default function Ranking() {
  const [board, setBoard] = useState("pontos");
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get(`/ranking?board=${board}`).then(({ data }) => setRows(data)); }, [board]);

  const medal = (pos) => (pos === 1 ? "text-[#FFD700]" : pos === 2 ? "text-[#C0C0C0]" : pos === 3 ? "text-[#CD7F32]" : "text-[#6b7280]");
  const isFichas = board === "fichas";

  return (
    <div className="dr-grain min-h-screen bg-[#090B0E]">
      <Navbar />
      <main className="relative z-20 max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-head text-3xl sm:text-4xl font-black mb-2">Ranking Global</h1>
        <p className="text-[#9CA3AF] mb-6">{isFichas ? "Os maiores acumuladores de fichas do modo diversão." : "Os melhores jogadores de Dominó Royalle."}</p>

        <div className="flex gap-2 mb-6" data-testid="rank-board-tabs">
          {BOARDS.map(([k, l, Icon]) => (
            <button key={k} onClick={() => setBoard(k)} data-testid={`rank-board-${k}`}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${board === k ? (k === "fichas" ? "bg-[#10B981] text-black" : "btn-gold") : "border border-white/10 text-[#9CA3AF] hover:text-white"}`}>
              <Icon size={15} /> {l}
            </button>
          ))}
        </div>

        <div className="dr-card overflow-hidden" data-testid="ranking-table">
          <div className="grid grid-cols-[40px_1fr_60px_60px_90px] sm:grid-cols-[50px_1fr_80px_80px_120px] gap-2 px-4 py-3 text-[10px] uppercase tracking-wider text-[#6b7280] border-b border-white/5">
            <span>#</span><span>Jogador</span><span className="text-right">V</span><span className="text-right">D</span><span className="text-right">{isFichas ? "Fichas" : "Pts"}</span>
          </div>
          {rows.length === 0 ? <p className="p-6 text-[#9CA3AF] text-sm">Sem jogadores no ranking ainda.</p> : rows.map((r) => (
            <div key={r.user_id} className="grid grid-cols-[40px_1fr_60px_60px_90px] sm:grid-cols-[50px_1fr_80px_80px_120px] gap-2 px-4 py-3 items-center border-b border-white/5 hover:bg-white/[0.02]" data-testid={`rank-row-${r.user_id}`}>
              <span className={`font-head font-black flex items-center gap-1 ${medal(r.position)}`}>{r.position <= 3 && <Crown size={14} />}{r.position}</span>
              <div className="flex items-center gap-2 min-w-0">
                <img src={r.avatar || "https://api.dicebear.com/7.x/initials/svg?seed=" + r.name} className="w-8 h-8 rounded-full shrink-0 object-cover" alt="" />
                <span className="font-semibold truncate">{r.name}</span>
              </div>
              <span className="text-right font-mono-num text-[#10B981]">{r.wins}</span>
              <span className="text-right font-mono-num text-[#EF4444]">{r.losses}</span>
              {isFichas
                ? <span className="text-right font-mono-num text-[#10B981] font-bold">{Number(r.virtual_credits || 0).toLocaleString("pt-BR")}</span>
                : <span className="text-right font-mono-num text-[#D4AF37] font-bold">{r.points}</span>}
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
